import { usePicture } from "@brickme/frontend-common/src/picture-edit/picture-edit-context.tsx";
import SliderInput from "~/components/slider-input.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import type { ConfirmSheetProps } from "~/components/sheet/confirm-sheet.tsx";
import ConfirmSheet from "~/components/sheet/confirm-sheet.tsx";

function ContrastSheet(
	props: Pick<ConfirmSheetProps, "open" | "onDone" | "onCancel">,
) {
	const t = useTranslator();
	const { picture, patchPictureDebounced } = usePicture();

	return (
		<ConfirmSheet title={t("Contrast")} {...props}>
			<form onSubmit={(e) => e.preventDefault()}>
				<SliderInput
					min={-100}
					max={100}
					step={1}
					value={Math.round(picture.contrast * 100)}
					onChange={(newValue) =>
						patchPictureDebounced({
							contrast: newValue / 100,
						})
					}
				/>
			</form>
		</ConfirmSheet>
	);
}

export default ContrastSheet;
